import { createContext } from 'react'
import { LangEum, LocalEum } from '@/constant'
import languages from './config/languages'

const context = createContext({
  pageId: '',
  activityType: '1',
  equity: 'both',
  lang: LangEum['en'],
  local: LocalEum.HK,
  ...languages['en'],
})

export default context
